var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDocumentAccessDenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "261.9838709677417 248.49999999999986 71.00000000000011 71.00000000000003",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M303.33 269.4L303.33 275.24L309.17 275.24",
    id: "a1wg2mCaj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33 269.4L285.8 269.4L285.8 298.6L309.17 298.6L309.17 275.24L303.33 269.4Z",
    id: "c5l2f0KGe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63 286.85L291.63 289.35L293.33 290.34L293.33 287.85L291.63 286.85ZM291.65 282.58L291.65 284.06L295.92 286.55L295.92 291.74L297.49 292.68L303.32 289.32L303.32 282.58L297.48 279.21L291.65 282.58Z",
    id: "a9M6nihad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.48 284C329.48 301.66 315.15 316 297.48 316C279.82 316 265.48 301.66 265.48 284C265.48 266.34 279.82 252 297.48 252C315.15 252 329.48 266.34 329.48 284Z",
    id: "csDr6Hnl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65 258.86L322.78 262.99L277.53 308.25L273.4 304.12L318.65 258.86Z",
    id: "afjBPF2LT"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1wg2mCaj",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1wg2mCaj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#003c71",
    strokeWidth: 2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5l2f0KGe",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5l2f0KGe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#003c71",
    strokeWidth: 2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9M6nihad",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9M6nihad",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#003c71",
    strokeWidth: 2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#csDr6Hnl",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#003c71",
    strokeWidth: 7,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afjBPF2LT",
    opacity: 1,
    fill: "#003c71",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAccessDenied);
export default __webpack_public_path__ + "static/media/document_access_denied.4c707390c5331ce23241c0777d6b6b0d.svg";
export { ForwardRef as ReactComponent };